var React = require('react');

function Y1 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Y1"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("g",{"style":{"mixBlendMode":"multiply"},"key":0},React.createElement("polygon",{"points":"41.51 25.77 24.74 0 0 0 28.41 43.67 41.51 25.77","fill":"#f47643"})),React.createElement("polygon",{"points":"72.17 0.24 47.43 0.24 11.74 80.27 36.48 80.27 72.17 0.24","fill":"#e5c83d","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

Y1.defaultProps = {"viewBox":"0 0 72.17 80.27"};

module.exports = Y1;

Y1.default = Y1;
